// useOtpTimer.js
import { useState, useEffect, useRef, useCallback } from "react";

/**
 * Custom hook for managing the countdown timer for OTP resend.
 * @param {number} initialSeconds - Initial countdown time in seconds
 * @param {function} onExpire - Callback when the timer expires (for resend OTP)
 */
export const useOtpTimer = (initialSeconds = 20, onExpire) => {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  const timerRef = useRef(null);

  const startTimer = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerRef.current);
          if (onExpire) onExpire();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  }, [onExpire]);

  const resetTimer = useCallback(() => {
    setTimeLeft(initialSeconds);
    startTimer();
  }, [initialSeconds, startTimer]);

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current);
  }, [startTimer]);

  return { timeLeft, resetTimer, startTimer };
};
